import React from 'react';

interface PowerOutageScheduleInputProps {
  testId?: string;
  className?: string;
  suffix?: string;
  value?: string;
  maxRange?: number | null;
  isFloat?: boolean;
  onChange?: (value: number | string | null) => void;
}

export const PowerOutageScheduleInput: React.FC<
  PowerOutageScheduleInputProps
> = ({
  testId,
  className,
  suffix,
  value,
  maxRange = 100,
  onChange,
  isFloat,
}) => {
  const validateAndParseValue = (value: string): number | string | null => {
    if (value === '' || !value || maxRange == null) {
      return null;
    } else if (value.match(/\d+\.\d*0$/)) {
      return value;
    } else if (value.match(/\d+\.$/)) {
      return value;
    } else {
      const numberValue = isFloat
        ? parseFloat(value)
        : parseInt(value.replace(/,/g, ''), 10);
      if (numberValue < 0 || isNaN(numberValue)) {
        return null;
      } else if (numberValue > maxRange) {
        return maxRange;
      } else if (numberValue >= 0 && numberValue <= maxRange) {
        return isFloat ? Math.round(numberValue * 10000) / 10000 : numberValue;
      } else {
        return null;
      }
    }
  };

  return (
    <div
      className={`relative h-[30px] rounded-[5px] border border-light-6 bg-white ${className}`}
    >
      <input
        className={`noto-13-semibold h-full w-[80%] rounded-[5px] p-[10px] text-dark-6 focus:outline-none`}
        data-testid={testId}
        value={value}
        onChange={(e) => onChange?.(validateAndParseValue(e.target.value))}
        type="text"
      ></input>
      <span className="noto-13-bold absolute right-3 top-1/2 -translate-y-1/2 leading-[23px] text-light-10">
        {suffix}
      </span>
    </div>
  );
};
